<template>
  <div class="pa-3">
    <v-btn
      v-if="new_quatation"
      @click="addQuotation()"
      class="font-weight-bold white--text rounded-lg"
      x-large
      depressed
      block
      color="primary"
    >
      <v-icon small left> fal fa-quote-right </v-icon>
      {{ quotationText }}
    </v-btn>
    <v-btn
      v-else
      @click="
        store_type === 'RESTAURANT' || store_type === 'BUFFET'
          ? handleTableClick()
          : dialogPayOpen()
      "
      class="font-weight-bold white--text rounded-lg"
      x-large
      depressed
      block
      color="primary"
    >
      <v-icon small left> fal fa-money-bill-wave-alt </v-icon>
      {{
        store_type === "RESTAURANT" || store_type === "BUFFET"
          ? tableButtonText
          : $t("payment")
      }}
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    new_quatation: {
      type: Boolean,
      default: false,
    },
    store_type: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      newQuotation: "index/newQuotation",
    }),
    quotationText() {
      const doc = this.newQuotation.document;
      if (this.newQuotation && this.newQuotation.update) {
        return this.$t("update_quotation");
      }
      return this.$t("new_quotation");
    },
    tableButtonText() {
      if (this.$route.query.tableId) {
        return this.$t("add_order");
      }
      return this.$t("choose_table");
    },
  },
  methods: {
    addQuotation() {
      this.$emit("addQuotation");
    },
    fetchTable() {
      this.$emit("fetchTable");
    },
    dialogPayOpen() {
      this.$emit("dialogPayOpen");
    },
    handleTableClick() {
      this.$emit("handleTableClick");
    },
  },
};
</script>

<style></style>
